import styled, { keyframes } from "styled-components";

const loading = keyframes`
  from {
    left: -50px;
    width: 30%;
  }

  50% {
    width: 30%;
  }

  70% {
    width: 70%;
  }

  80% {
    left: 50%;
  }

  95% {
    left: 120%;
  }

  to {
    left: 100%;
  }
`;

export const LoaderLayer = styled.div`
  display: ${props => (props.isLoading ? "block" : "none")};
  position: absolute;
  top: 0;
  left: 0;
  padding-top: 215px;
  width: 100%;
  height: 100%;
  z-index: 4;
`;

export const LoaderContainer = styled.div`
  margin: 0 auto;
  width: 200px;
`;

export const Loader = styled.div`
  display: ${props => (props.isLoading ? "block" : "none")};
  height: 5px;
  width: 200px;
  overflow: hidden;
  background-color: #cccccc;

  &:before {
    display: block;
    content: "";
    width: 200px;
    height: 5px;
    background-color: ${({ theme }) => theme.loadingColor};
    animation: ${loading} 2s linear infinite;
  }
`;

export const Text = styled.p`
  display: ${props => (props.isLoading ? "block" : "none")};
  text-align: center;
  width: 200px;
  height: 30px;
  margin-top: 16px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 12px;
`;
